/*!
 *
 *  Web Starter Kit
 *  Copyright 2015 Google Inc. All rights reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *    https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License
 *
 */
/* eslint-env browser */
(function() {
  'use strict';

  // Check to make sure service workers are supported in the current browser,
  // and that the current page is accessed from a secure origin. Using a
  // service worker from an insecure origin will trigger JS console errors. See
  // http://www.chromium.org/Home/chromium-security/prefer-secure-origins-for-powerful-new-features
  var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === '[::1]' ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
    );

  if ('serviceWorker' in navigator &&
      (window.location.protocol === 'https:' || isLocalhost)) {
    navigator.serviceWorker.register('service-worker.js')
    .then(function(registration) {
      // updatefound is fired if service-worker.js changes.
      registration.onupdatefound = function() {
        // updatefound is also fired the very first time the SW is installed,
        // and there's no need to prompt for a reload at that point.
        // So check here to see if the page is already controlled,
        // i.e. whether there's an existing service worker.
        if (navigator.serviceWorker.controller) {
          // The updatefound event implies that registration.installing is set:
          // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
          var installingWorker = registration.installing;

          installingWorker.onstatechange = function() {
            switch (installingWorker.state) {
              case 'installed':
                // At this point, the old content will have been purged and the
                // fresh content will have been added to the cache.
                // It's the perfect time to display a "New content is
                // available; please refresh." message in the page's interface.
                break;

              case 'redundant':
                throw new Error('The installing ' +
                                'service worker became redundant.');

              default:
                // Ignore
            }
          };
        }
      };
    }).catch(function(e) {
      console.error('Error during service worker registration:', e);
    });
  }

  // Your custom JavaScript goes here
  var app = angular.module("webPage", ['ngAnimate', 'ngMaterial', 'ngMessages', 'ui.router', 'materialCalendar']);
  app.config(['$mdThemingProvider', '$stateProvider', '$urlRouterProvider', function ($mdThemingProvider, $stateProvider, $urlRouterProvider) {
    var meinWeg= {
      name: 'meinWeg',
      url: '/MeinWeg',
      templateUrl: 'templates/meinWeg.html'
    };
    var meineAngebote= {
      name: 'meineAngebote',
      url: '/MeineAngebote',
      templateUrl: 'templates/meineAngebote.html'
    };
    var gespraechstherapie= {
      name: 'gespraechstherapie',
      url: '/Gespraechstherapie',
      templateUrl: 'templates/gespraechstherapie.html'
    };
    var paartherapie= {
      name: 'paartherapie',
      url: '/Paartherapie',
      templateUrl: 'templates/paartherapie.html'
    };
    var autogenesTrainig= {
      name: 'autogenesTrainig',
      url: '/AutogenesTrainig',
      templateUrl: 'templates/autogenesTrainig.html'
    };
    var pmr= {
      name: 'pmr',
      url: '/PMR',
      templateUrl: 'templates/pmr.html'
    };
    var lachyoga= {
      name: 'lachyoga',
      url: '/Lachyoga',
      templateUrl: 'templates/lachyoga.html'
    };
    var kinderSeite= {
      name: 'kinderSeite',
      url: '/Kinderseite',
      templateUrl: 'templates/kinderSeite.html'
    };
    var hypnose= {
      name: 'hypnose',
      url: '/Hypnose',
      templateUrl: 'templates/hypnose.html'
    };
    var emdr= {
      name: 'emdr',
      url: '/EMDR',
      templateUrl: 'templates/emdr.html'
    };
    var hypnoBirthing= {
      name: 'hypnoBirthing',
      url: '/HypnoBirthing',
      templateUrl: 'templates/hypnoBirthing.html'
    };
    var kosten= {
      name: 'kosten',
      url: '/KostenKonditionen',
      templateUrl: 'templates/kosten.html'
    };
    var kontakt= {
      name: 'kontakt',
      url: '/Kontakt',
      templateUrl: 'templates/kontakt.html'
    };
    var aktuelleGruppenAngebote= {
      name: 'aktuelleGruppenAngebote',
      url: '/AktuelleGruppenAngebote',
      templateUrl: 'templates/aktuelleGruppenAngebote.html'
    };
    var kinderAngebote= {
      name: 'kinderAngebote',
      url: '/AngeboteKinder',
      templateUrl: 'templates/kinderAngebote.html'
    };
    var pmrAngebote= {
      name: 'pmrAngebote',
      url: '/AngebotePmr',
      templateUrl: 'templates/pmrAngebote.html'
    };
    var autogenesTrainigAngebote= {
      name: 'autogenesTrainigAngebote',
      url: '/AutogenesTrainigAngebote',
      templateUrl: 'templates/autogenesTrainigAngebote.html'
    };
    var gespraechsrunde= {
      name: 'gespraechsrunde',
      url: '/Gesprächsrunde',
      templateUrl: 'templates/gespraechsrunde.html'
    };
    var genuss= {
      name: 'genuss',
      url: '/Genuss',
      templateUrl: 'templates/genuss.html'
    };
    var lachyogaAngebot= {
      name: 'lachyogaAngebot',
      url: '/LachyogaAngebot',
      templateUrl: 'templates/lachyogaAngebot.html'
    };
    var hypnoBirthingAngebot= {
      name: 'hypnoBirthingAngebot',
      url: '/HypnoBirthing',
      templateUrl: 'templates/hypnoBirthingAngebot.html'
    };
    var rauchfreiAngebot= {
      name: 'rauchfreiAngebot',
      url: '/Rauchfrei',
      templateUrl: 'templates/rauchfreiAngebot.html'
    };
    $urlRouterProvider.otherwise(function () {
      console.log("Hey");
    });


    $stateProvider.state(meinWeg);
    $stateProvider.state(meineAngebote);
    $stateProvider.state(gespraechstherapie);
    $stateProvider.state(paartherapie);
    $stateProvider.state(autogenesTrainig);
    $stateProvider.state(pmr);
    $stateProvider.state(lachyoga);
    $stateProvider.state(kinderSeite);
    $stateProvider.state(hypnose);
    $stateProvider.state(emdr);
    $stateProvider.state(hypnoBirthing);
    $stateProvider.state(kosten);
    $stateProvider.state(kontakt);
    $stateProvider.state(kinderAngebote);
    $stateProvider.state(pmrAngebote);
    $stateProvider.state(autogenesTrainigAngebote);
    $stateProvider.state(aktuelleGruppenAngebote);
    $stateProvider.state(gespraechsrunde);
    $stateProvider.state(genuss);
    $stateProvider.state(hypnoBirthingAngebot);
    $stateProvider.state(lachyogaAngebot);
    $stateProvider.state(rauchfreiAngebot);
    //$stateProvider.state(testStatee);
    $mdThemingProvider.theme('default').primaryPalette('purple').accentPalette('orange');
  }]);
  app.controller("appController", ['$scope', '$mdMenu', '$state', '$window', '$filter', '$http', '$q', function ($scope, $mdMenu, $state, $window, $filter, $http, $q) {

    $scope.open = function ($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    };
    $scope.close = function () {
      //$mdMenu.hide();
    };

    $scope.goTo = function (stateName) {

      $state.go(stateName);

      //$scope.show = !$scope.show;

    };
    $scope.shouldDisplay = function () {
      return $state.current.name;

    };


    $scope.dayFormat = "d";

    // To select a single date, make sure the ngModel is not an array.
    $scope.selectedDate = null;

    // If you want multi-date select, initialize it as an array.
    $scope.selectedDate = [];

    $scope.firstDayOfWeek = 1; // First day of the week, 0 for Sunday, 1 for Monday, etc.
    $scope.setDirection = function(direction) {
      $scope.direction = direction;
      $scope.dayFormat = direction === "vertical" ? "EEEE, MMMM d" : "d";
    };

    $scope.dayClick = function(date) {
      $scope.msg = "You clicked " + $filter("date")(date, "MMM d, y h:mm:ss a Z");
    };

    $scope.prevMonth = function(data) {
      $scope.msg = "You clicked (prev) month " + data.month + ", " + data.year;
    };

    $scope.nextMonth = function(data) {
      $scope.msg = "You clicked (next) month " + data.month + ", " + data.year;
    };

    var isInRange = function (d, start, end) {
      return (
        isFinite(d) &&
        isFinite(start) &&
        isFinite(end) ?
          start <= d && d <= end :
          NaN
      );

    };



    var getMonthWeek = function(d){
      var firstDay = new Date(d.getFullYear(), d.getMonth(), 1).getDay();
      return Math.ceil((d.getDate() + firstDay)/7);
    };

    $scope.tooltips = true;
    $scope.setDayContent = function(date) {
      var pStack = "";
      var processedDate = new Date(date);
      var lachyogaBegin = new Date(2017, 4, 8);
      var lachyogaEnd = new Date(2017, 8, 1);
      var tranceBegin = new Date(2017, 3, 4);
      var tranceEnd = new Date(2017, 11, 1);
      var muskelBegin = new Date(2017, 5, 2);
      var muskelEnd = new Date(2017, 11, 7);
      var rundeBegin = new Date(2017, 4, 3);
      var rundeEnd = new Date(2017, 11, 7);
      var atBegin = new Date(2017, 8, 3);
      var atEnd = new Date(2017, 11, 8);

      var tranceAusfall = new Date(2017, 3, 25);
      var gespraechAusfall = new Date(2017, 4, 24);
      var lachyogaAusfall = new Date(2017, 4, 29);

      if(processedDate.getFullYear() === 2017){
        switch (processedDate.getDay()){
          case 1:
            if(isInRange(processedDate, lachyogaBegin, lachyogaEnd) && processedDate.getTime() != lachyogaAusfall.getTime()){
              pStack = pStack + "<span>Lachyoga im Lachgarten, 17:00-18:00 Uhr</span>";
            }
            break;
          case 2:
            if(isInRange(processedDate, tranceBegin, tranceEnd) && processedDate.getTime() != tranceAusfall.getTime()){
              pStack = pStack + "<p>Entspannung durch Trancegeschichten, 17:00-18:30 Uhr</p>";
            }
            if(isInRange(processedDate, muskelBegin, muskelEnd)){
              pStack = pStack + "<p>Progressive Muskelentspannung, 19:00-20:30 Uhr</p>";
            }
            break;
          case 3:
            if(isInRange(processedDate, rundeBegin, rundeEnd) && getMonthWeek(processedDate) === 1 && processedDate.getTime() != gespraechAusfall.getTime()){
              pStack = pStack + "<p>Gesprächsrunde/wechselnde Themen, 19:00-20:30 Uhr</p>";
            }
            break;
          case 4:
            if(isInRange(processedDate, atBegin, atEnd)){
              pStack = pStack + "<p>Autogenes Training, 18:00-19:30 Uhr</p>";
            }
            break;
          case 5:
            break;
          case 6:
            break;
        }
      }

      // You would inject any HTML you wanted for
      // that particular date here.
      return pStack;

      // You could also use an $http function directly.
      return $http.get("/some/external/api");

      // You could also use a promise.
      var deferred = $q.defer();
      $timeout(function() {
        deferred.resolve("<p></p>");
      }, 1000);
      return deferred.promise;

    };

  }]);

})();

